import { z } from 'zod';
import { ArtistIdSchema, IsoDateSchema } from './common.js';
import { PeriodSchema } from './periods.js';
export const CONCENTRATION_BANDS = ['top1', '2-5', '6-10', '11-20', '21+'];
export const ConcentrationBandSchema = z.enum(CONCENTRATION_BANDS);
export const VINTAGE_ERAS = [
    'pre-2015',
    '2015-17',
    '2018-20',
    '2021-23',
    '2024+',
    'unknown',
];
export const VintageEraSchema = z.enum(VINTAGE_ERAS);
export const MarketSliceSchema = z.object({
    location: z.string(),
    name: z.string(),
    streams: z.number(),
    /** Outside US/CA/AA Luminate delivers premium streams only: a different basis. */
    premiumOnly: z.boolean(),
    /** Whether every day of the window is held for this location. */
    complete: z.boolean(),
});
export const MarketsSchema = z.object({
    window: z.object({ start: IsoDateSchema, end: IsoDateSchema }),
    /** artist_daily_streams AA over the window; null when not held. */
    worldwide: z.number().nullable(),
    top: z.array(MarketSliceSchema),
    restOfWorld: z.number().nullable(),
    status: z.enum(['ok', 'not_ingested', 'partial']),
});
export const ArtistSummarySchema = z.object({
    artistId: ArtistIdSchema,
    artistName: z.string(),
    anchor: IsoDateSchema,
    periods: z.array(PeriodSchema),
    territories: z.array(z.string()),
    trackCount: z.number().int(),
    overrideCount: z.number().int(),
    hero: z.object({
        /** Sum of held tracks, AA, LTM (what the sheet calls Total Artist). */
        ltmWorldwide: z.number(),
        perDay: z.number(),
        spotifyMonthlyListeners: z.number().nullable(),
    }),
    artistLevel: z.object({
        /** artist_daily_streams AA over LTM: Luminate's whole-catalogue figure. */
        ltmWorldwide: z.number().nullable(),
        /** Σ held tracks / artist-level, over LTM. */
        tracksCoverage: z.number().nullable(),
    }),
    concentration: z.array(z.object({ band: ConcentrationBandSchema, streams: z.number() })),
    vintage: z.array(z.object({ era: VintageEraSchema, streams: z.number() })),
    markets: MarketsSchema,
});
//# sourceMappingURL=summary.js.map